import axios from 'axios';

const api = axios.create({
    // baseURL: 'https://api.usepeppr.ai/api',
    baseURL: 'https://api.usepeppr.ai/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

// GitHub integration endpoints
export const githubApi = {
    startAuth: async () => {
        const response = await api.get('/github/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    getActivity: async () => {
        const response = await api.get('/github/activity');
        return response.data;
    },

    checkStatus: async () => {
        return await api.get('/github/status');
    },

    disconnect: async () => {
        return await api.post('/github/disconnect');
    }
};

// Slack integration endpoints
export const slackApi = {
    startAuth: async () => {
        const response = await api.get('/slack/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    checkStatus: async () => {
        return await api.get('/slack/status');
    },

    getActivity: async () => {
        const response = await api.get('/slack/activity');
        return response.data;
    },

    disconnect: async () => {
        return await api.post('/slack/disconnect');
    }
};

// Jira integration endpoints
export const jiraApi = {
    startAuth: async () => {
        const response = await api.get('/jira/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    checkStatus: async () => {
        return await api.get('/jira/status');
    },

    getActivity: async () => {
        return await api.get('/jira/activity');
    },

    disconnect: async () => {
        return await api.post('/jira/disconnect');
    }
};

// Linear integration endpoints
export const linearApi = {
    startAuth: async () => {
        const response = await api.get('/linear/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    checkStatus: async () => {
        return await api.get('/linear/status');
    },

    getActivity: async () => {
        return await api.get('/linear/activity');
    },

    disconnect: async () => {
        return await api.post('/linear/disconnect');
    }
};

// Notion integration endpoints
export const notionApi = {
    startAuth: async () => {
        const response = await api.get('/notion/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    checkStatus: async () => {
        return await api.get('/notion/status');
    },

    getDocuments: async () => {
        return await api.get('/notion/documents');
    },

    getActivity: async () => {
        return await api.get('/notion/activity');
    },

    disconnect: async () => {
        return await api.post('/notion/disconnect');
    }
};

// Google integration endpoints
export const googleApi = {
    startAuth: async () => {
        const response = await api.get('/google/auth');
        const { auth_url } = response.data;
        window.location.href = auth_url;
    },

    checkStatus: async () => {
        return await api.get('/google/status');
    },

    getActivity: async () => {
        const response = await api.get('/google/activity');
        return response.data;
    },

    disconnect: async () => {
        return await api.post('/google/disconnect');
    }
};

// Error handling interceptor
api.interceptors.response.use(
    response => response,
    error => {
        console.error('API Error:', {
            status: error.response?.status,
            data: error.response?.data,
            headers: error.response?.headers,
            config: error.config
        });
        return Promise.reject(error);
    }
);

export default api;